import { useJobContext } from 'hb-react/shared/apps/JobForm/contexts/JobContext';
import { Select } from 'hb-react/shared/components/formik/components/inputs';

export const Contract = () => {
  const { contractTypes = [] } = useJobContext();

  const options = contractTypes.map(({ id, name }) => ({
    id,
    name: I18n.t(name),
  }));

  return (
    <Select
      label={s__('JobForm|Type of contract')}
      name="contract_type_id"
      options={options}
    />
  );
};
